export const AVAILABLE = 'dostepne';
export const DEVELOPER_PULL = 'Pula dewelopera';
